import React from 'react'
import { Modal, Descriptions } from 'antd'
import ImagePictureCard from '@/components/ImagePictureCard'
import styles from './index.less'

const DetectionResult = ({
  onCancel,
  result = {}
}) => {
  const images = result.attachment ? [{ url: result.attachment, id: 1 }] : []

  return (
    <>
      <div className='result-summary'>
        <div className='summary-label'>脑健康测评</div>
        <div className='summary-content'>
          <Descriptions column={2}>
            <Descriptions.Item label='大脑负荷结果'>{result.brainLoad}</Descriptions.Item>
            <Descriptions.Item label='大脑活力结果'>{result.brainVitality}</Descriptions.Item>
            <Descriptions.Item label='紧张兴奋结果'>{result.tensionExcitement}</Descriptions.Item>
            <Descriptions.Item label='大脑疲劳结果'>{result.tireDegree}</Descriptions.Item>
            <Descriptions.Item label='情绪压力结果'>{result.emotionStress}</Descriptions.Item>
            <Descriptions.Item label='无意记忆结果'>{result.unintentionalMemory}</Descriptions.Item>
            <Descriptions.Item label='投入程度结果'>{result.focusDegree}</Descriptions.Item>
            <Descriptions.Item label='困倦指数结果'>{result.drowsinessIndex}</Descriptions.Item>
            <Descriptions.Item label='放松程度结果'>{result.relaxDegree}</Descriptions.Item>
            <Descriptions.Item label='脑稳定程度结果'>{result.brainStability}</Descriptions.Item>
            <Descriptions.Item label='思绪排空结果'>{result.thoughtsEmptying}</Descriptions.Item>
            <Descriptions.Item label='左右优势结果'>{result.leftAndRight}</Descriptions.Item>
            <Descriptions.Item label='上传的附件'>
              <ImagePictureCard images={images} />
            </Descriptions.Item>
          </Descriptions>
        </div>
      </div>
      <div className='result-summary'>
        <div className='summary-label'>报告综述</div>
        <div className='summary-content'>{result.summarize}</div>
      </div>
    </>
  )
}

export default DetectionResult
